import React from 'react';

import { Button } from '../Button';

export type TTab = {
  id: string;
  key: string;
  label: string;
  active: boolean;
  viewed: boolean;
  recommendationId: string;
  theme?: string;
};

type TProps = {
  data: TTab;
  onClick: (tabId: string) => void;
};

export function Tab({ data, onClick }: TProps) {
  const isActive = data.active ? 'vitrine-template__tab--active' : '';
  const className = `vitrine-template__tab ${isActive} ${data.theme ?? ''}`;

  return (
    <Button
      className={className.trim()}
      text={data.label}
      onClick={() => onClick(data.id)}
      isPill
      isOutlined
    />
  );
}
